var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesGrid = function SvgShotEyesGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesGrid_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesGrid_svg__st1{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3c-.6 0-1 .4-1 1v16c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9h20M8.8 9v12M15.2 9v12M2 15h20M22 4v16c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V4",
    className: "shotEyesGrid_svg__st1"
  })));
};
export default SvgShotEyesGrid;